export enum ControllerRoute {
  Contact = 'Contact',
  Courseware = 'courseware',
  Notification = 'Notification',
  Eula = 'eula/PilotWebApp', // !important case sensitive
  Annotations = 'annotations',
  AnnotationCommands = 'annotationCommands',
  Document = 'document',
  TrainingEvent = 'trainingevent',
  TrainingPackage = 'trainingpackage',
  TrainingRecord = 'trainingrecord',
  User = 'user',
  Schedule = 'Schedule',
  ScheduleNotification = 'ScheduleNotification',
  DocumentViewerStatus = 'DocumentViewerStatus',
  RecentlyViewedDocuments = 'RecentlyViewedDocuments',
  Bookmarks = 'bookmarks',
  Visits = 'visits',
}
